<template lang="pug">
  .shop-product-category.container(v-if="categoryGroups")
    .container.xs-f-small.md-f-medium.max-at-tweak(v-for="(group, index) in categoryGroups"  :key="index")
      .row(v-if="cmsSettings.topCustomComponents && cmsSettings.topCustomComponents.length")
        template(v-for="(componentConfig, index) in cmsSettings.topCustomComponents" :key="`top-${index}`")
          CMSPartial(v-if="componentConfig.mixin_key === 'partial-loader'" :mixin-key="componentConfig.settings.partial")
          ComponentResolver(v-else :component-name="componentConfig.mixin_key" :component-props="componentConfig.settings")

      .row(v-if="cmsSettings.showCategoryHeader")
        .xs-12(v-if="group.mainCategory && group.mainCategory.main_image")
          .a-box-xs-4x3.a-box-sm-4x1
            .a-box-content
              responsive-image.main-category-image(:media-obj="JSON.parse(group.mainCategory.main_image)" xs-aspect-key="4x3" sm-aspect-key="4x1")

            .v-center.full-width.text-center(v-if="group.groupByProductType")
              h1.upper.f-secondary.mb-10.color-white.xs-f-large.md-f-xxlarge.lg-f-xxxlarge.max-at-tweak(v-if="index == 0 && group.mainCategory.display_name") {{ group.mainCategory.display_name }}
              h2.upper.color-white.xs-f-large.md-f-xxlarge.lg-f-xxxlarge.max-at-tweak(v-else) {{ group.mainCategory.display_name }}
              p.xs-f-small.max-at-tweak.color-white.sm-max-width-30.md-plus-max-width-40.m-auto(v-if="group.mainCategory.description") {{ group.mainCategory.description }}

        .xs-12.mt-30.text-left.main-title-wrap(v-else)
          h1.capitalize.f-secondary.xs-f-xlarge.sm-f-xxlarge.md-f-xxxlarge.lg-f-xxxlarge.max-at-tweak(v-if="index == 0") {{ group.groupTitle || group.mainCategory.display_name }}
          h2.upper.xs-f-medium.sm-f-large.md-f-xxlarge.lg-f-xxxlarge.max-at-tweak(v-else) {{ group.groupTitle }}

      .row(v-if="cmsSettings.belowCategoryHeaderComponents && cmsSettings.belowCategoryHeaderComponents.length")
        template(v-for="(componentConfig, index) in cmsSettings.belowCategoryHeaderComponents" :key="`below-${index}`")
          CMSPartial(v-if="componentConfig.mixin_key === 'partial-loader'" :mixin-key="componentConfig.settings.partial")
          ComponentResolver(v-else :component-name="componentConfig.mixin_key" :component-props="componentConfig.settings")

      .row
        template(v-if="group.groupByProductType")
          .product-type-wrap.xs-12(v-for="(productType, index) in group.productsByProductType" :key="index")
            .xs-12.title-wrap(v-if="!(productType.productsBySubCategory && productType.productsBySubCategory.length) || (group.productsByProductType.length > 1)")
              h1.text-color-2.capitalize.f-secondary.xs-f-xlarge.md-f-xxlarge.lg-f-xxxlarge.max-at-tweak(v-if="(!group.mainCategory?.display_name && group.mainCategory?.main_image || !cmsSettings.showCategoryHeader) && index === 0") {{ group.groupTitle || productType.product_type_display_name }}
              h4.product-type-title.text-color-2.upper.semi-bold.xs-f-medium.max-at-tweak {{ productType.product_type_display_name }}

            .xs-12(v-if="productType.productsBySubCategory && productType.productsBySubCategory.length")
              .sub-category-group.xs-12(v-for="subCategoryGroup in productType.productsBySubCategory")
                .sub-category-title-desc.xs-12.pb-200m
                  h5.sub-category-title.text-color-2.upper.semi-bold.xs-f-xmedium.max-at-tweak {{ subCategoryGroup.subCategory.display_name }}
                  p.sub-category-desc.text-color-4.xs-f-small.max-at-tweak.pt-50m {{ subCategoryGroup.subCategory.description }}

                .product-tiles.xs-12
                  ShopProductTile.xs-6.sm-4.lg-3(v-for="product in subCategoryGroup.products"  :key="`${index}-${product.id}`"  :product="product"  :averageReview="productsReviewsMap[product.id]"  :productUrl="`/product/${product.url_key}?your_pick=1`")

                  .shop-product-tile.xs-6.sm-4.lg-3(v-if="productType.product_type == 'color_kit'")
                    .a-box-xs-1x1.color-adv
                      .a-box-content.color-adv-container.text-center
                        .v-center
                          p.xs-f-xsmall.sm-f-small.max-at-tweak
                            | See your&nbsp;
                            a.underline(href='/shop/hair-color' tabindex="0") personalized recommendations
                            br
                            br
                            | For a free color consultation, call&nbsp;
                            br
                            a.underline(:href="`tel:${contactPhone}`" target="_self" @click="trackMREvent('Shop - Call for a free color consultation')" tabindex="0") {{contactPhone}}

            .xs-12(v-else)
              .product-tiles.inner-wrap.fixed-width-tweak-upper
                ShopProductTile.xs-6.sm-4.lg-3(v-for="product in productType.products"  :key="`${index}-${product.id}`"  :product="product"  :averageReview="productsReviewsMap[product.id]"  :productUrl="`/product/${product.url_key}?your_pick=1`")

                .shop-product-tile.xs-6.sm-4.lg-3(v-if="productType.product_type == 'color_kit'")
                  .a-box-xs-1x1.color-adv
                    .a-box-content.color-adv-container.text-center
                      .v-center
                        p.xs-f-xsmall.sm-f-small.max-at-tweak
                          | See your&nbsp;
                          a.underline(href='/shop/hair-color' tabindex="0") personalized recommendations
                          br
                          br
                          | For a free color consultation, call&nbsp;
                          br
                          a.underline(:href="`tel:${contactPhone}`" target="_self" @click="trackMREvent('Shop - Call for a free color consultation')" tabindex="0") {{contactPhone}}

        template(v-else)
          .product-type-wrap.xs-12
            .xs-12.text-center-on-desktop
              h1.product-type-title.upper.semi-bold.xs-f-xmedium.md-f-large.max-at-tweak(v-if="!group.mainCategory?.display_name && group.mainCategory?.main_image && !group.productsBySubCategory?.length") {{ group.groupTitle }}
              h4.product-type-title.upper.semi-bold.xs-f-medium.md-f-xmedium.max-at-tweak(v-else-if="group.mainCategory.display_name && !cmsSettings.showCategoryHeader") {{ group.mainCategory.display_name }}

            .xs-12(v-if="group.productsBySubCategory && group.productsBySubCategory.length")
              .sub-category-group.xs-12(v-for="(subCategoryGroup, index) in group.productsBySubCategory")
                .sub-category-title-desc.xs-12.pb-200m
                  h1.text-color-2.capitalize.mb-10.f-secondary.xs-f-xlarge.md-f-xxlarge.lg-f-xxxlarge.max-at-tweak(v-if="!group.mainCategory.display_name && index === 0") {{ group.groupTitle }}
                  h5.sub-category-title.text-color-2.upper.semi-bold.xs-f-xmedium.max-at-tweak {{ subCategoryGroup.subCategory.display_name }}
                  p.sub-category-desc.text-color-4.xs-f-small.max-at-tweak.pt-50m {{ subCategoryGroup.subCategory.description }}

                .product-tiles.xs-12
                  ShopProductTile.xs-6.sm-4.lg-3(v-for="product in subCategoryGroup.products"  :key="`${index}-${product.id}`"  :product="product"  :averageReview="productsReviewsMap[product.id]"  :productUrl="`/product/${product.url_key}?your_pick=1`")

            .xs-12.product-tiles(v-else)
              template(v-for="(productType, index) in group.productsByProductType" :key="`product-type-${index}`")
                ShopProductTile(v-for="product in productType.products" :product="product"  :averageReview="productsReviewsMap[product.id]"  :productUrl="`/product/${product.url_key}?your_pick=1`")

      .row(v-if="cmsSettings.bottomCustomComponents && cmsSettings.bottomCustomComponents.length")
        LazyComponent(v-for="(componentConfig, index) in cmsSettings.bottomCustomComponents")
          template(#default="{ shown }")
            CMSPartial(v-if="componentConfig.mixin_key === 'partial-loader'" :mixin-key="componentConfig.settings.partial")
            ComponentResolver(v-else :component-name="componentConfig.mixin_key" :component-props="componentConfig.settings")

</template>

<script>
  import { defineAsyncComponent } from 'vue';
  import { mapState, mapActions } from 'vuex';

  import ShopProductTile from './ShopProductTile';
  import CMSPartial from '@components/CMSPartial';
  import LazyComponent from '@components/LazyComponent';
  import ComponentResolver from '@components/ComponentResolver';
  import { addGtagDynamicRemarketingEvent } from '@utilities/eventTrackingUtils';

  export default {
    name: 'ShopProductCategory',

    components: {
      ShopProductTile,
      CMSPartial,
      LazyComponent,
      ComponentResolver,
      ContactUs: defineAsyncComponent(() => import(/* webpackChunkName: 'HomePage' */ '@components/HomePage/ContactUs'))
    },

    inject: ['getObjProperty'],

    props: {
      keys: {
        type: Array,
        default() {
          return [];
        },
      },
    },

    data() {
      return {
        categoryGroups: null,
        productsReviewsMap: {},
        actualKeysUsed: [],
      };
    },

    computed: {
      ...mapState('global', ['MRConfig', 'isVueSSRApp']),
      ...mapState('cms', ['cmsSettings']),
      ...mapState('shopCategory', ['categoryData']),

      contactPhone() {
        return this.MRConfig?.contactPhone;
      },
    },

    async created() {
      if (!this.categoryData) {
        await this.loadCategoryData({ keys: this.keys });
      }
      this.handleCategoryData(this.categoryData);
    },

    async serverPrefetch() {
      if (this.isVueSSRApp) {
        await this.loadCategoryData({ keys: this.keys });
        this.handleCategoryData(this.categoryData);
      }
    },

    mounted() {
      const products = this.categoryGroups.reduce((acc, group) => {
        const groupProds = group.productsByProductType?.reduce((acc, type) => {
          acc.push(...type.products);
          return acc;
        }, []);

        acc.push(...groupProds);
        return acc;
      }, []);
      addGtagDynamicRemarketingEvent(
        'view_item_list',
        null,
        products.map((product) => ({
          'id': product.id,
          'google_business_vertical': 'retail'
        }))
      );
    },

    methods: {
      ...mapActions('shopCategory', ['loadCategoryData']),

      handleCategoryData(data) {
        this.actualKeysUsed = data.categoryKeys;

        if (typeof document !== 'undefined') {
          document.title = data.categoryMetaTitle;
          let metaDescriptionTag = document.querySelector("head > meta[name='description']");

          if (!metaDescriptionTag) {
            metaDescriptionTag = document.createElement('meta');
            metaDescriptionTag.name = "description";
            document.getElementsByTagName('head')[0].appendChild(metaDescriptionTag);
          }

          metaDescriptionTag.content = data.categoryMetaDescription;
        }

        this.categoryGroups = data.categoryGroups;
        this.productsReviewsMap = data.productsReviewsMap;
      }
    },
  };
</script>

<style lang="stylus" scoped>
.shop-product-category
  .product-tiles
    display flex
    flex-wrap wrap

  .sub-category-group
    position relative
    padding-bottom 1em
    margin-bottom 1.5em
    padding-top 1em

    .sub-category-title-desc
      padding-left 2.5%
      padding-right 2.5%
      padding-bottom 2em

    .sub-category-desc
      max-width 35em

    &:after
      content ''
      position absolute
      left 0
      bottom 0
      width 100%
      border-top 1px solid ui-color-5

  .main-title-wrap
    padding-left 5%

    @media mq-tablet-less
      padding-left 2.5%

  .product-type-wrap
    padding-top 0.5em
    padding-left 3%
    padding-right 3%

    @media mq-tablet-less
      padding-top 0.5em

    .inner-wrap
      width 100%
      display flex
      flex-direction row
      flex-wrap wrap
      justify-content left

      @media mq-mobile
        column-gap 0%

    .product-type-title
      padding 1em 0

      @media mq-tablet-less
        padding-top 0

    .shop-product-tile
      margin-bottom 1em
      max-width 14.44em

    @media mq-tablet-less
      .shop-product-tile
        max-width 50%

  .color-adv
    padding 5% 0em

    .color-adv-container
      box-sizing border-box
      background-color color-white
      border 1px solid ui-color-5
      border-radius 0.5em

      .v-center
        padding 0 10%

      @media mq-mobile
        padding 3% 0% 7%

  .product
    text-align center

  @media mq-desktop-md-plus
    .product-type-wrap
      padding-left 5%
      padding-right 5%

</style>
